import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";
import { useEffect, useState } from "react";

export default function Tags({
  onChange,
  error,
  helperText,
  blur,
  category = "residential",
  values,
}) {
  const [list, setList] = useState([]);
  const getAmmenities = async () => {
    const data = {
      url: apis().ammenityList + "?type=" + category,
    };

    const result = await httpAction(data);
    if (result?.status) {
      const filter = result?.list?.map((item) => item?.title);
      setList(filter);
    }
  };

  useEffect(() => {
    getAmmenities();
  }, [category]);

  return (
    <Autocomplete
      size="small"
      value={Array.from(values) ? values : []}
      multiple
      onChange={onChange}
      id="tags-outlined"
      options={list}
      getOptionLabel={(option) => option}
      filterSelectedOptions
      renderInput={(params) => (
        <TextField
          error={error}
          helperText={helperText}
          onBlur={blur}
          {...params}
          label="Select Ammenities"
        />
      )}
    />
  );
}
